import {BASENAME} from '../../router/constants';
import { storyblokStoryUuidToUrl } from '../../helpers/URLHelpers';

/// Link
// external_link:string -> any url that is not internal
// storyblok_link_field: Storyblok Link Object from the field data
// storyblok_richtext_link: Storyblok Link Object from the richtext object (different than field)
// override_link_target:string The forced value for the link target.
// extend_path:string Adds additional path to a story (Used for tag results)
function LegacyLink({
  external_link,
  storyblok_link_field,
  storyblok_richtext_link,
  extend_path,
  override_link_target,
  withClass,
  activeClass,
  onClick,
  children,
  full_slug,
  article_link,
  story_uuid
}) {
  let linkUrl = "";
  let linkTarget = "_self";
  let isActive = false;

  if (external_link) {
    linkUrl = external_link;
  }
  // Link Field Links
  if (storyblok_link_field) {
    linkUrl = storyblokLinkFieldToHref(storyblok_link_field) || `/${BASENAME}`;
    if (storyblok_link_field.target) {
      linkTarget = storyblok_link_field.target;
    }
    if (storyblok_link_field.anchor) {
      linkUrl += "#" + storyblok_link_field.anchor;
      if (linkUrl.includes('/#')) linkUrl = linkUrl.replace('/#', '#')
    }
    if(activeClass && window && typeof window !== "undefined" && linkUrl === window.location.pathname) {
      isActive = true;
    }
  }
  // Richtext Links
  if (storyblok_richtext_link) {
    linkUrl = richtextLinkToHref(storyblok_richtext_link);
    linkTarget = storyblok_richtext_link.target;
    if (storyblok_richtext_link.anchor) {
      linkUrl += "#" + storyblok_richtext_link.anchor;
    }
  }
  // Storyblok uuid
  if (story_uuid) {
    linkUrl = storyblokStoryUuidToUrl(story_uuid) || '';
    if(linkUrl && extend_path) {
      if(!linkUrl.endsWith("/")) {
        linkUrl += "/";
      }
      linkUrl += extend_path;
    }
  }
  // New Window Override
  if (override_link_target) {
    linkTarget = override_link_target;
  }

  if (full_slug) {
    linkUrl = full_slug
  }

  if (article_link) {
    linkUrl = article_link
  }

  let classList = []
  if(withClass) { classList.push(withClass) }
  if(isActive) { classList.push(activeClass) }
  return (
    <a
      href={linkUrl}
      target={linkTarget}
      onClick={onClick}
      className={classList.join(" ")}
    >
      {children}
    </a>
  );
}

function storyblokLinkFieldToHref(storyblok_link) {
  switch (storyblok_link.linktype) {
    case "asset":
      return storyblok_link.url;
    case "email":
      return `mailto:${storyblok_link.email}`;
    case "url":
      return storyblok_link.url;
    default:
      let formattedLink = storyblok_link.cached_url.replace(/\/\//g, "/");
      formattedLink = formattedLink.startsWith("/") ? formattedLink : `/${formattedLink}`;
      formattedLink = formattedLink.endsWith("/") ? formattedLink : `${formattedLink}/`;

      return formattedLink;
  }
}

function richtextLinkToHref(storyblok_link) {
  switch (storyblok_link.linktype) {
    case "asset":
      return storyblok_link.href;
    case "email":
      return `mailto:${storyblok_link.href}`;
    case "url":
      return storyblok_link.href;
    default:
      // starts with https:// or http:// or www
      if (storyblok_link.href.match(/^(https?:\/\/|www\.)/)) {
        return storyblok_link.href;
      }

      // replace first and last chars if they are slashes with nothing
      let formattedLink = storyblok_link.href.replace(/news\//, "");
      formattedLink = formattedLink.replace(/^\/|\/$/g, "");

      return formattedLink.match(/articles\//) ? "#" : formattedLink;
  }
}

export default LegacyLink;
